import { useTranslation } from "react-i18next";
import { useTheme } from "@repo/tokens";
import { Box, Icon, Modal } from "@repo/ui";

import OneQuestionGoodImage from "../../../../assets/instructions/One_Question_Good_Image.svg";
import OneQuestionBadImage from "../../../../assets/instructions/One_Question_Bad_Image.svg";
import EnglishOnlyGoodImage from "../../../../assets/instructions/English_only_Good_Image.svg";
import EnglishOnlyBadImage from "../../../../assets/instructions/English_only_Bad_Image.svg";
import ClearHandWritingGoodImage from "../../../../assets/instructions/Clear_HandWriting_Good_Image.svg";
import ClearHandWritingBadImage from "../../../../assets/instructions/Clear_HandWriting_Bad_Image.svg";
import BlurryGoodImage from "../../../../assets/instructions/Blurry_Good_Image.svg";
import BlurryBadImage from "../../../../assets/instructions/Blurry_Bad_Image.svg";
import BrightGoodImage from "../../../../assets/instructions/Bright_good_image.svg";
import BrightBadImage from "../../../../assets/instructions/Bright_bad_image.svg";
import StraightGoodImage from "../../../../assets/instructions/Straight_good_image.svg";
import StraightBadImage from "../../../../assets/instructions/Straight_bad_image.svg";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

type InstructionRow = {
  questionKey: string;
  goodSrc: string;
  badSrc: string;
};

const instructionRows: InstructionRow[] = [
  {
    questionKey: "instruction_one_question",
    goodSrc: OneQuestionGoodImage,
    badSrc: OneQuestionBadImage,
  },
  {
    questionKey: "instruction_english_only",
    goodSrc: EnglishOnlyGoodImage,
    badSrc: EnglishOnlyBadImage,
  },
  {
    questionKey: "instruction_clear_handwriting",
    goodSrc: ClearHandWritingGoodImage,
    badSrc: ClearHandWritingBadImage,
  },
  {
    questionKey: "no_blurry_photos",
    goodSrc: BlurryGoodImage,
    badSrc: BlurryBadImage,
  },
  {
    questionKey: "instruction_bright_not_dark",
    goodSrc: BrightGoodImage,
    badSrc: BrightBadImage,
  },
  {
    questionKey: "instruction_take_straight_photo",
    goodSrc: StraightGoodImage,
    badSrc: StraightBadImage,
  },
];

export function InstructionsModal({ isOpen, onClose }: Props) {
  const { t } = useTranslation("doubts");
  const { theme } = useTheme();

  const header = (
    <Box className="modal-header">
      <div className="aq-modal-title">{t("instructions_title")}</div>
      <button
        type="button"
        className="close-icon-wrapper"
        onClick={onClose}
        aria-label={t("cancel")}
      >
        <Icon
          name="close"
          width={24}
          height={24}
          color={theme.colors.primary[40]}
        />
      </button>
    </Box>
  );

  const body = (
    <div className="aq-instructions-modal-inner">
      <div className="aq-modal-body aq-instructions-body">
        <div className="aq-instructions-card">
          {instructionRows.map((row, index) => (
            <div key={row.questionKey} className="aq-instruction-row">
              <p className="aq-instruction-step-title">
                {t("instruction_step", { n: index + 1 })} {t(row.questionKey)}
              </p>
              <div className="aq-instruction-pair">
                <figure className="aq-instruction-figure aq-instruction-figure--good">
                  <img
                    src={row.goodSrc}
                    alt=""
                    className="aq-instruction-img"
                  />
                </figure>
                <figure className="aq-instruction-figure aq-instruction-figure--bad">
                  <img src={row.badSrc} alt="" className="aq-instruction-img" />
                </figure>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <Modal
      isModalOpen={isOpen}
      onClose={onClose}
      showFooter={false}
      width="55.938rem"
      height="45.75rem"
      customHeader={header}
      body={body}
      alignItems="center"
    />
  );
}
